var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 73,
    viewBox: "0 0 113 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.093 67.453c-14.636-.153-30.04-1.348-44.284-3.694-3.08-.585-1.917-3.352 1.355-2.882 12.706 1.88 25.606 3.068 38.7 3.449 13.095.38 30.62.541 40.841-5.088 5.207-2.873 5.028-8.068 5.424-11.991.593-5.77.416-11.657-.147-17.43-.37-5.773-1.318-11.663-2.458-17.437-.57-3.118-3.445-8.205-.934-10.969.193-.23.77-.229.963-.113 4.424 2.09 4.216 7.976 4.978 11.095 1.523 6.93 2.275 13.742 2.835 20.67.556 8.427 3.41 21.594-7.2 28.261-9.26 6.094-27.363 6.163-40.073 6.13z",
    fill: "#6ABAA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.833 65.439c-1.923-1.354-1.531-3.663.59-4.62 6.554-2.68 12.535-6.9 19.09-9.58 1.928-.765 2.883 2.126 1.34 3.085-5.015 3.068-10.03 5.944-15.045 9.012l4.616 2.323c2.501.97 5.004 1.169 7.312 2.33 1.731.775.955 3.084-.395 3.658-5.397 1.912-13.087-3.116-17.508-6.209z",
    fill: "#6ABAA4"
  })));
}

export default __webpack_public_path__ + "./fonts/pointer.aa8cb72b8d48d60866a360d3fe1adb01.svg";
export { SvgPointer as ReactComponent };